/**
 * E-056 follow-on — per-destination failing-streak signal for Export History.
 * Fetches GET /api/export-records/destination-health once; the signal is
 * advisory, so any fetch failure degrades to "no banner", never a broken page.
 */
import { useState, useEffect } from "react";
import { api } from "@/lib/api-client";
import type { DestinationHealth } from "../components/DestinationHealthBanner";

export function useDestinationHealth() {
  const [destinations, setDestinations] = useState<DestinationHealth[]>([]);

  useEffect(() => {
    let cancelled = false;
    api
      .get<{ destinations: DestinationHealth[] }>("/export-records/destination-health")
      .then((data) => {
        if (!cancelled) setDestinations(data.destinations);
      })
      .catch(() => {
        /* advisory signal — stay silent */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { destinations };
}
